import {
    MAP_SALESCHANNEL_TO_VIRTUAL_ID,
    MAP_TARIFF_ID_TO_SALESCHANNEL,
    RedplusTariff,
    RedTariff,
    SAILS_BNT_STORAGE,
    SAILS_PARAM_SALESCHANNEL,
    SalesChannel,
    SALESCHANNEL_CONSUMER,
    YoungTariff,
} from '@vfde-sails/constants';
import { getQueryParam } from '@vfde-sails/utils';
import {
    getSalesChannelFromSails,
    getSessionStorageItemJson,
} from '@vfde-sails/storage';
import {
    APP,
    CONTAINER_TARIFF,
} from '../../../app/constants';
import { getSubscriptionFromUrl } from './getSubscription';
import { SailsDeviceDetailsStorage } from '../../../interfaces/storage';

/**
 * Get the saleschannel from given subscription ID. Returns default "consumer".
 */
export const getSaleschannel = (): SalesChannel =>
    getSalesChannelFromUrl() ?? getSalesChannelFromStorage() ?? getSalesChannelFromSubscription() ?? SALESCHANNEL_CONSUMER;

/**
 * Get Saleschannel from URL
 */
export const getSalesChannelFromUrl = (): SalesChannel | null => {
    const salesChannelFromUrl = getQueryParam(SAILS_PARAM_SALESCHANNEL);

    if (salesChannelFromUrl && Object.keys(MAP_SALESCHANNEL_TO_VIRTUAL_ID).includes(salesChannelFromUrl)) {
        return salesChannelFromUrl as SalesChannel;
    }

    return null;
};

/**
 * Get saleschannel from storage
 */
export const getSalesChannelFromStorage = (): SalesChannel | undefined => {
    const storage = getSessionStorageItemJson<SailsDeviceDetailsStorage | null>(SAILS_BNT_STORAGE);

    if (!storage) {
        return undefined;
    }

    return (
        getSalesChannelFromBackup(storage) ?? getSalesChannelFromSails(storage)
    );
};

/**
 *
 */
export const getSalesChannelFromBackup = (storage: SailsDeviceDetailsStorage | null): SalesChannel | undefined =>
    storage?.[APP]?.[CONTAINER_TARIFF]?.[SAILS_PARAM_SALESCHANNEL];

/**
 * Get sales channel from subscription ID
 */
export const getSalesChannelFromSubscription = (): SalesChannel | null => {
    const subscriptionFromUrl = getSubscriptionFromUrl() as RedTariff | YoungTariff | RedplusTariff;

    if (!subscriptionFromUrl) {
        return null;
    }

    return MAP_TARIFF_ID_TO_SALESCHANNEL[subscriptionFromUrl]?.[0];
};
